import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  availableCandidates: [],
  isFetchingAvailableCandidates: false,
  applicationComments: [],
  isLoadingApplicationComments: false,
  isLoadingApplicationQuestions: false,
  bookingApplicationQuestions: [],
  currentUserApplication: null,
  isFetchingCurrentUserApplication: false,
  allApplications: [],
  isFetchingAllApplications: false,
  isFetchingCurrentApplication: false,
  currentApplication: null,
  isFetchingCurrentApplicationAnswers: false,
  currentApplicationAnswers: []
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
